import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

import Navbar from "./components/navbar";
import Home from "./components/home";
import Contact from "./components/contact";
import ProductDetail from "./components/productDetail";
import Checkout from "./components/checkout";
import Cart from "./components/cart";
import OrderHistory from "./components/orderHistory";
import Menu from "./components/menu";
import Footer from "./components/footer";
import ScrollToTop from "./components/scrollToTop";

// PageWrapper adds animation to all pages
const pageVariants = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20 },
};

const pageTransition = {
  type: "spring",
  stiffness: 100,
  damping: 20,
};

function PageWrapper({ children }) {
  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={pageTransition}
      className="w-full h-full"
    >
      {children}
    </motion.div>
  );
}

export default function App() {
  const location = useLocation();

  return (
    <div className="App">
      <Navbar />
      <ScrollToTop />

      {/* AnimatePresence handles exit animations */}
      <AnimatePresence mode="wait" initial={false}>
        <Routes location={location} key={location.pathname}>
          <Route
            path="/"
            element={
              <PageWrapper>
                <Home />
              </PageWrapper>
            }
          />
          <Route
            path="/menu"
            element={
              <PageWrapper>
                <Menu />
              </PageWrapper>
            }
          />
          <Route
            path="/contact"
            element={
              <PageWrapper>
                <Contact />
              </PageWrapper>
            }
          />
          <Route
            path="/product/:id"
            element={
              <PageWrapper>
                <ProductDetail />
              </PageWrapper>
            }
          />
          <Route
            path="/cart"
            element={
              <PageWrapper>
                <Cart />
              </PageWrapper>
            }
          />
          <Route
            path="/checkout"
            element={
              <PageWrapper>
                <Checkout />
              </PageWrapper>
            }
          />

          <Route
            path="/orders"
            element={
              <PageWrapper>
                <OrderHistory />
              </PageWrapper>
            }
          />
        </Routes>
      </AnimatePresence>

      <Footer />
    </div>
  );
}

// Wrap App with Router in index.jsx
export function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}
